/*@flow*/
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import commands from './commands';
import MetricsContext from './MetricsContext';
import { useContext, forwardRef } from 'react';
import TipJar from './TipJar';

const ActionButtons = () => {
  const ctx = useContext(MetricsContext);
  return (
    <div
      css={css(`
        padding: 10px 10px 8px;
        font-size: 1.2rem;
        border-bottom: solid 1px #999;
        button {
          border: solid 1px #ccc;
          color: #333;
          padding: 5px 10px;
        }
      `)}
    >
      <button onClick={() => commands(ctx).newWidget()}>New analysis</button>
    </div>
  );
};

const Component = (_, ref) => (
    <div ref={ref}>
      <ActionButtons />
      <TipJar />
    </div>
  );

export default (forwardRef<any, any>(Component): React$AbstractComponent<any, any>);
